import React, { FC, useState } from 'react';
import SocialsList from 'shared/SocialsList/SocialsList';
import Label from 'components/Label/Label';
import Input from 'shared/Input/Input';
import Textarea from 'shared/Textarea/Textarea';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import emailjs from '@emailjs/browser';

export interface PageContactProps {
  className?: string;
}

const info = [
  {
    title: '💌 EMAIL',
    desc: 'contact@fleexoff.com',
  },
];

const PageContact: FC<PageContactProps> = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');

  const [notSent, setSent] = useState(true);

  const handleSubmit = () => {
    emailjs.send(
      'service_9y8en9e',
      'template_pyttnhc',
      {
        email: email,
        message: message,
        name: name,
      },
      'I8jGdIx__fwaH3Wsm',
    );
    setSent(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <div className="mb-24 lg:mb-32">
        <h2 className="my-16 sm:my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Contact
        </h2>
        <div className="container max-w-7xl mx-auto">
          <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-12 ">
            <div className="max-w-sm space-y-8">
              {info.map((item, index) => (
                <div key={index}>
                  <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                    {item.title}
                  </h3>
                  <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    {item.desc}
                  </span>
                </div>
              ))}
              <div>
                <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                  🌏 Nous retrouver
                </h3>
                <SocialsList className="mt-2" />
              </div>
            </div>
            <div>
              {notSent ? (
                <div className="grid grid-cols-1 gap-6">
                  <label className="block">
                    <Label>Nom</Label>

                    <Input
                      placeholder="Jean Dupont"
                      type="text"
                      className="mt-1"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </label>
                  <label className="block">
                    <Label>Email</Label>

                    <Input
                      type="email"
                      placeholder="example@example.com"
                      className="mt-1"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </label>
                  <label className="block">
                    <Label>Message</Label>

                    <Textarea
                      className="mt-1"
                      rows={6}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </label>
                  <div>
                    <ButtonPrimary onClick={() => handleSubmit()}>
                      Envoyer
                    </ButtonPrimary>
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-6">
                  Demande de contact envoyée
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContact;
